import * as angular from 'angular';
import HttpProvider from './http.provider';
import httpInterceptor from './http.interceptor.factory';

export default angular
  .module('HttpModule', [])
  .provider('HttpService', HttpProvider)
  .factory('httpInterceptor', httpInterceptor)
  .name;



// WEBPACK FOOTER //
// ./src/app/core/http/http.module.js